import z from "zod";
const SingleUseActionTokenBase = {
    /**
     * The primary identifier for this token
     */
    id: z.uuid(),
    /**
     * The status of this token
     * - "pending": The token is valid and can be used
     * - "used": The token has been used and can no longer be used
     * - "deleted": The token has been deleted and can no longer be used
     */
    status: z.enum(["pending", "used", "deleted"]),
    /**
     * The date and time this token was created
     */
    created: z.iso.datetime(),
};
export const SingleUseActionTokenAssignPatientNhsNumberSchema = z.object({
    type: z.literal("assignPatientNhsNumber"),
    context: z.object({
        /**
         * The id of the team which is allowed to use this token.
         * Updates will be constrained to patient records which are visible to this team.
         */
        teamId: z.uuid(),
    }),
});
export const SingleUseActionTokenPatientBulkImportSchema = z.object({
    type: z.literal("patientBulkImport"),
    context: z.object({
        /**
         * The id of the team which is allowed to use this token.
         */
        teamId: z.uuid(),
        /**
         * The external system identifier, e.g. "rio/{instanceId}" or "pds/00000000-00000000-00000000-00000000"
         */
        externalSystem: z.string(),
        /**
         * Optional trust information associated with the import
         */
        trust: z
            .object({
            name: z.string(),
            odsCode: z.string(),
        })
            .optional(),
    }),
});
export const SingleUseActionTokenBulkUserEmailMigrationSchema = z.object({
    type: z.literal("bulkUserEmailMigration"),
    context: z.object({
        /**
         * The id of the organisation whose user emails this token may migrate.
         * Validation is scoped to this organisation and the user lane only.
         */
        organisationId: z.uuid(),
    }),
});
export const SingleUseActionTokenBulkTeamEmailMigrationSchema = z.object({
    type: z.literal("bulkTeamEmailMigration"),
    context: z.object({
        /**
         * The id of the organisation whose team emails this token may migrate.
         * Validation is scoped to this organisation and the team lane only.
         */
        organisationId: z.uuid(),
    }),
});
/**
 * This token is used to authorise an end-user to perform a bulk action.
 */
export const SingleUseActionTokenSchema = z.discriminatedUnion("type", [
    SingleUseActionTokenAssignPatientNhsNumberSchema.extend(SingleUseActionTokenBase),
    SingleUseActionTokenPatientBulkImportSchema.extend(SingleUseActionTokenBase),
    SingleUseActionTokenBulkUserEmailMigrationSchema.extend(SingleUseActionTokenBase),
    SingleUseActionTokenBulkTeamEmailMigrationSchema.extend(SingleUseActionTokenBase),
]);
export const CreateSingleUseActionTokenRequestSchema = z.discriminatedUnion("type", [
    SingleUseActionTokenAssignPatientNhsNumberSchema,
    SingleUseActionTokenPatientBulkImportSchema,
    SingleUseActionTokenBulkUserEmailMigrationSchema,
    SingleUseActionTokenBulkTeamEmailMigrationSchema,
]);
export const SINGLE_USE_ACTION_TOKEN_MAX_AGE_MONTHS = 1;
//# sourceMappingURL=singleUseActionToken.js.map